import { Disclosure, Menu, Transition } from "@headlessui/react";
import { logout } from "../../../utils/auth";
import { Avatar, Col, Dropdown, Form, Input, Layout, Modal, Row, Space, Typography } from "antd";
import React, { Fragment, ReactElement, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { LOGOUT } from "../../../redux/auth/authType";
import { responseNotification } from "../../../utils/notify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Client } from "@stomp/stompjs";
import {
  faKey,
  faPowerOff,
} from "@fortawesome/free-solid-svg-icons";
import noImage from "../../../images/noImage.png";
import Cookies from "js-cookie";
import ringer from "./flipdish-ringer.mp3";
import { AppstoreOutlined, DownOutlined, HeartOutlined, MailOutlined, MobileOutlined, PhoneOutlined, UserAddOutlined, UserOutlined } from "@ant-design/icons";

const { Header } = Layout;
const { Text } = Typography;
const MainHeader = (): ReactElement => {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const helpMenu = {
    items: [
      { key: "1", label: <a href="#">Help Center</a> },
      { key: "2", label: <a href="#">Track Order</a> },
      { key: "3", label: <a href="#">Contact Support</a> },
    ],
  };
  const { merchantInfo, token, shopInfo, shopId } = useSelector(
    (state) => (state as any)?.authReducer
  );
  const initialState = useSelector((state) => (state as any)?.authReducer);
  const [loading, setLoading] = useState(false);
  const [visible, setVisible] = useState(false);
  const [orderId, setOrderId] = useState();
  const audio = new Audio(ringer);
  audio.loop = false;

  const Logout = () => {
    logout("/");
    dispatch({
      type: LOGOUT,
      payload: {
        token: null,
      },
    });
    setTimeout(() => {
      navigate("/");
    }, 100); // 100 milliseconds wait
  };

  const onSubmit = async (data: any) => {
    setLoading(true);

    const readyData = data && {
      mobileNumber: data?.mobileNumber,
      oldPassword: data?.oldPassword,
      newPassword: data?.newPassword,
    };

    await fetch(`${process.env.REACT_APP_AUTH_API}/merchant/update-password`, {
      method: "PUT",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(readyData),
    })
      .then((res) => res.json())
      .then((res) => {
        setLoading(false);

        if (res.statusCode === 200) {
          form.resetFields();
          setVisible(false);
          responseNotification("Password Updated Successfully", "success");
        } else if (res.status === 500) {
          responseNotification("Internal server error", "error");
        } else {
          responseNotification(res.message || "something wrong", "warning");
        }
      })
      .catch((err) => {
        setLoading(false);
        responseNotification(`${"Internal server error"} ${err}`, "error");
        console.error("err", err);
      });
  };

  function classNames(...classes: string[]) {
    return classes.filter(Boolean).join(" ");
  }
  const stompConnect = () => {
    const client = new Client({
      brokerURL: `${process.env.REACT_APP_SOCKET_API}/merchant`,
      debug: function (str) {
        console.log(str);
      },
      reconnectDelay: 20000,
      heartbeatIncoming: 10000,
      heartbeatOutgoing: 10000,
    });

    client.onConnect = function (frame) {
      client.subscribe("/user/queue/merchant", (message) => {
        if (JSON.parse(message.body).orderId) {
          setOrderId(JSON.parse(message.body).orderId);
          Cookies.set("newOrders", JSON.parse(message.body).orderId);
          audio.play();
        }
      });
      client.publish({
        destination: "/app/merchant/status",
        body: JSON.stringify({
          status: shopInfo?.status,
          token: token,
        }),
      });
    };

    if (token) {
      client.activate();
    } else {
      client.deactivate();
    }
  };

  useEffect(() => {
    if (shopId) {
      stompConnect();
    }
  }, [shopId]);

  return (
<header className="w-full border-b bg-gray-50 text-gray-700">
      {/* 🔹 Top Bar */}
      <div className="max-w-7xl mx-auto flex justify-between items-center py-2 px-4 text-sm">
        {/* Left Side */}
        <div className="flex items-center space-x-4">
  {/* 📞 Phone */}
  <a
    href="tel:09638111600"
    className="flex items-center space-x-1 text-gray-700 hover:text-blue-600 transition"
  >
    <PhoneOutlined className="text-gray-500" />
    <span>09638111600</span>
  </a>

  {/* 📧 Email */}
  <a
    href="mailto:support@jachai.com"
    className="flex items-center space-x-1 text-gray-700 hover:text-blue-600 transition"
  >
    <MailOutlined className="text-gray-500" />
    <span>support@jachai.com</span>
  </a>
</div>


        {/* Right Side */}
        <div className="flex items-center space-x-5">
          <Dropdown menu={helpMenu} trigger={["click"]}>
            <a onClick={(e) => e.preventDefault()} className="hover:text-blue-600 cursor-pointer">
              <Space>
                Help
                <DownOutlined className="text-xs" />
              </Space>
            </a>
          </Dropdown>

          <div className="flex items-center space-x-1 hover:text-blue-600 cursor-pointer">
            <AppstoreOutlined />
            <span>App!</span>
          </div>

          <div className="flex items-center space-x-1 hover:text-blue-600 cursor-pointer">
            <HeartOutlined />
            <span>Wishlist</span>
          </div>

          <div className="flex items-center space-x-1 hover:text-blue-600 cursor-pointer">
            <UserOutlined />
            <div className="hidden md:block">
                    <div className="ml-2 flex items-center">
                      <Menu as="div" className="ml-3 relative">
                        <div>
                          <Menu.Button className="max-w-xs bg-gray-200 rounded-full flex items-center text-sm focus:outline-none focus:ring-1 focus:ring-offset-1 focus:ring-offset-gray-400 focus:ring-white">
                            <span className="sr-only">Open user menu</span>

                            <span className="px-3 font-medium text-sm">
                              {shopInfo?.name ||
                                merchantInfo?.fullName ||
                                merchantInfo?.mobileNumber?.split("+88")}
                            </span>

                            {merchantInfo?.profilePicture ? (
                              <img
                                className="w-10 h-10 p-1 rounded-full ring-2 ring-gray-300 dark:ring-gray-500"
                                src={
                                  merchantInfo?.storeDetails?.storeLogo ||
                                  merchantInfo?.profilePicture ||
                                  shopInfo?.logo ||
                                  noImage
                                }
                                alt=""
                              />
                            ) : (
                              <svg
                                className="mx-auto w-9 h-9 text-gray-400"
                                fill="currentColor"
                                viewBox="0 0 20 20"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  fillRule="evenodd"
                                  d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-6-3a2 2 0 11-4 0 2 2 0 014 0zm-2 4a5 5 0 00-4.546 2.916A5.986 5.986 0 0010 16a5.986 5.986 0 004.546-2.084A5 5 0 0010 11z"
                                  clipRule="evenodd"
                                ></path>
                              </svg>
                            )}
                          </Menu.Button>
                        </div>
                        <Transition
                          as={Fragment}
                          enter="transition ease-out duration-100"
                          enterFrom="transform opacity-0 scale-95"
                          enterTo="transform opacity-100 scale-100"
                          leave="transition ease-in duration-75"
                          leaveFrom="transform opacity-100 scale-100"
                          leaveTo="transform opacity-0 scale-95"
                        >
                          <Menu.Items className="origin-top-right absolute right-0 mt-2 w-48 rounded-md shadow-lg py-1 bg-white ring-1 ring-black ring-opacity-5 focus:outline-none z-50">
                            {!!merchantInfo?.profilePicture && (
                              <div className="px-4 text-center pb-2 border-b z-50">
                                <Avatar
                                  size={120}
                                  src={
                                    merchantInfo?.storeDetails?.storeLogo ||
                                    merchantInfo
                                      ?.profilePicture ||
                                    shopInfo?.logo ||
                                    noImage
                                  }
                                  alt=""
                                  className="border mb-3"
                                />
                                <p className="font-medium text-sm">
                                  {merchantInfo?.fullName || shopInfo?.name}
                                </p>
                                <p className="font-light text-sm">
                                  {merchantInfo?.email}
                                </p>
                              </div>
                            )}
                            
                            <Menu.Item>
                              {({ active }) => (
                                <Link
                                  to="#"
                                  className={classNames(
                                    active ? "bg-gray-100" : "",
                                    "flex items-center px-4 py-2 text-sm text-gray-500 hover:text-gray-600 font-medium "
                                  )}
                                  onClick={() => setVisible(true)}
                                >
                                  <FontAwesomeIcon icon={faKey} />
                                  <span className="ml-2">Change Password</span>
                                </Link>
                              )}
                            </Menu.Item>
                            <Menu.Item>
                              {({ active }) => (
                                <Link
                                  to="#"
                                  className={classNames(
                                    active ? "bg-gray-100" : "",
                                    "flex items-center px-4 py-2 text-sm text-gray-500 hover:text-red-500 font-bold "
                                  )}
                                  onClick={Logout}
                                >
                                  <FontAwesomeIcon icon={faPowerOff} />
                                  <span className="ml-2">Logout</span>
                                </Link>
                              )}
                            </Menu.Item>
                            
                          </Menu.Items>
                        </Transition>
                      </Menu>
                    </div>
                  </div>
          </div>
        </div>
      </div>

      {/* 🔹 Main Logo Section */}
      <div className="w-full bg-white py-5 shadow-sm">
        <div className="max-w-7xl mx-auto flex items-center justify-start px-4">
        <img
        loading="lazy"
        src="https://cdn.builder.io/api/v1/image/assets/TEMP/ea4c26a74b02db0dd27625d95e75148c411cd8cfc3189e65ed44d128d9fe8073?placeholderIfAbsent=true&apiKey=fca3da21012743ce8f0bf226c9b50cd7"
        alt="Company Logo"
        className="object-contain max-w-full aspect-[3.1] w-[140px]"
      />
        </div>
      </div>
    </header>
   
  );
};

export default MainHeader;
